var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{
        '--flipped': _vm.isFlipped,
        '--deg15'  : _vm.isDeg15,
        '--zoom'   : _vm.isZoomed,
    },attrs:{"data-card":_vm.slug},on:{"click":_vm.onClick}},[_c('div',{staticClass:"card__wrapper"},[_c('div',{staticClass:"card__recto"},[_c('card-image',{attrs:{"slug":_vm.slug}})],1),_c('div',{staticClass:"card__verso"},[_c('card-image',{attrs:{"slug":"verso"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }